module.exports = __webpack_public_path__ + "static/media/3-sits_soffor.f9cdb09e.jpg";